import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as AsymmetryVariableRangesSelectors from '../selectors/asymmetry-variable-ranges.selectors';
import * as AsymmetryVariableRangesStore from '../reducers/asymmetry-variable-ranges.reducer';
import { AsymmetryVariableRanges } from '@sleipai/sleip-models';
import { Observable } from 'rxjs';

@Injectable()
export class AsymmetryVariableRangesStoreFacade {
  constructor(
    private readonly store: Store<AsymmetryVariableRangesStore.State>
  ) {}

  getAsymmetryVariableRangesById$ = (id: string) =>
    this.store.pipe(
      select(
        AsymmetryVariableRangesSelectors.selectSingleAsymmetryVariableRange(id)
      )
    );

  getAsymmetryVariableRanges$: Observable<AsymmetryVariableRanges[]> =
    this.store.pipe(
      select(AsymmetryVariableRangesSelectors.selectAllAsymmetryVariableRange)
    );
}
